module.exports = __webpack_public_path__ + "./Tim_pbw_0c5751442e9d9b82bf3cf45bcb081b77.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2024/Tim_pbw.png
// module id = 619
// module chunks = 0